import types from './types';

const updateChemProdTitle = () => ({
  type: types.UPDATE_CHEM_PROD_TITLE
});

export default {
  updateChemProdTitle
};
